module.exports = __webpack_public_path__ + "img/avi.0a4144b4.png";